"use strict";

var _interopRequireDefault = require("D:/00_GIT/hotel/hotel-front-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _net_bar = require("@/api/net_bar");
var _form = _interopRequireDefault(require("./form.vue"));
var _mixin = _interopRequireDefault(require("@/utils/mixin"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "NetBarStoreRecharge",
  mixins: [_mixin.default],
  components: {
    NetBarStoreRechargeFrom: _form.default
  },
  props: {
    storeId: {
      type: [String, Number]
    }
  },
  data: function data() {
    return {
      list: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 20
      },
      pagination: "",
      rechargeId: "",
      rechargeFormVisible: false
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _net_bar.fetchStoreRechargeList)(this.storeId, this.listQuery).then(function (response) {
        var data = response.data;
        _this.list = data.data;
        _this.pagination = data;
        _this.listQuery.page = data.current_page;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    addHandler: function addHandler() {
      this.rechargeId = "";
      this.rechargeFormVisible = true;
    },
    editHandler: function editHandler(record) {
      this.rechargeId = record.id;
      this.rechargeFormVisible = true;
    },
    statusChangeHandler: function statusChangeHandler(record) {
      var _this2 = this;
      (0, _net_bar.updateStoreRechargeStatus)(this.storeId, record.id, record.status ? 0 : 1).then(function () {
        _this2.getList();
        _this2.$message.success("操作成功");
      });
    },
    rechargeAddEnabled: function rechargeAddEnabled() {
      // 非财务
      return !this.isRoleBill();
    },
    rechargeEditEnabled: function rechargeEditEnabled(record) {
      // 未上架，且非财务
      return !record.status && !this.isRoleBill();
    },
    rechargeStatusEnabled: function rechargeStatusEnabled() {
      // 管理员或财务
      return this.isRoleAdmin() || this.isRoleBill();
    }
  }
};
exports.default = _default;